import cn from 'classnames';
import * as React from 'react';
import defaultAvatarImg from '../assets/images/img_avatar.png';
import { formatInitials } from '../utils/string.utils';
import theme from './Avatar.module.scss';
export var Avatar = React.memo(function (_a) {
    var className = _a.className, user = _a.user, id = _a.id, initials = _a.initials, size = _a.size, onClick = _a.onClick, _b = _a.fallbackToImage, fallbackToImage = _b === void 0 ? false : _b;
    var imageAvatar = user && user.profile && user.profile.avatar
        ? user.profile.avatar
        : fallbackToImage
            ? defaultAvatarImg
            : undefined;
    var isInitial = !imageAvatar;
    var letters = isInitial ? (user ? formatInitials(user.name) : initials || '') : '';
    var isRounded = !isInitial && imageAvatar && imageAvatar.includes('tinygraphs.com');
    return (React.createElement("div", { id: id, onClick: onClick, className: cn(theme.avatar, isInitial && theme.avatar_initial, size === 'xxs' && theme.avatar_xxs, size === 'xs' && theme.avatar_xs, size === 'xl' && theme.avatar_xl, className) }, isInitial ? (letters) : (React.createElement("img", { className: cn(theme.img, isRounded && theme.img_round), src: imageAvatar }))));
});
//# sourceMappingURL=Avatar.js.map